import Slider from 'react-slick'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import MovieItem from '../MovieItem'

const MoviesSlider = props => {
  const {movieList} = props
  const settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
  }
  return (
    <div
      style={{
        width: '98%',
        margin: '20px',
        padding: '20px',
      }}
    >
      <Slider {...settings}>
        {movieList.map(movie => (
          <MovieItem key={movie.id} movie={movie} />
        ))}
      </Slider>
    </div>
  )
}

export default MoviesSlider
